var ProductCustomizerBundle = class extends HTMLElement {
	constructor() {
      super();

      this.products = [];
      this.productIds = [];
      this.colorMap = new Map();
      this.typeMap = new Map();
      this.sectionId = "template--15201135591498__product-customizer-bundle";

      this.productList = JSON.parse(this.dataset['products']);
      const sortedArr = [...this.productList].sort((p, p1) => {
        if ( p.variant < p1.variant ){
          return -1;
        }
        if ( p.variant > p1.variant ){
          return 1;
        }
        return 0;
      })

      for (const product of sortedArr) {
        this.productIds.push(product.id);
        if (!this.colorMap.has(product.color)) {
          this.colorMap.set(product.color, product.id);
        }
        if (!this.typeMap.has(product.type)) {
          this.typeMap.set(product.type, product.id);
        }
      }
    }

	connectedCallback() {
      const searchQuery = this.productIds.map(item => {
        return `id:${item}`;
      }).join(' OR ') + ' OR render:true';

      fetch(`/search?q=${ searchQuery }&section_id=${ this.sectionId }&type=product`, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.text()).then(this.handleProductResponse.bind(this));
	}

	handleProductResponse(text) {
      const parser = new DOMParser();
      const dom = parser.parseFromString(text, 'text/html');
      this.products = dom.querySelectorAll('.section .container > .product');
	}

	render(id) {
      for (const product of this.products) {
        if (product.dataset['id'] === `${id}`) {
          this.setInnerHTML(this, product.outerHTML);
          break;
        }
      }
	}

  setInnerHTML(elm, html) {
    elm.innerHTML = html;
    
    Array.from(elm.querySelectorAll("script"))
      .forEach( oldScriptEl => {
        const newScriptEl = document.createElement("script");
        
        Array.from(oldScriptEl.attributes).forEach( attr => {
          newScriptEl.setAttribute(attr.name, attr.value) 
        });
        
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        newScriptEl.appendChild(scriptText);
        
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
    });
  }
}

var CustomizerColorSelect = class extends HTMLElement {
  constructor() {
    super();

    this.color = this.dataset['color'];
    this.container = this.closest('product-customizer-bundle');

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    this.container.render(this.container.colorMap.get(this.color));
  }

  goToNext() {
    if (this.nextElementSibling) {
      this.nextElementSibling.click();
    } else {
      this.parentElement.children[0].click();
    }
  }

  goToPrev() {
    if (this.previousElementSibling) {
      this.previousElementSibling.click();
    } else {
      this.parentElement.children[this.parentElement.children.length - 1].click();
    }
  }
}

var CustomizerTypeSelect = class extends HTMLElement {
	constructor() {
		super();

    this.type = this.dataset['type'];
    this.container = this.closest('product-customizer-bundle');

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    this.container.render(this.container.typeMap.get(this.type));
  }
  
  goToNext() {
    if (this.nextElementSibling) {
      this.nextElementSibling.click();
    } else {
      this.parentElement.children[0].click();
    }
  }

  goToPrev() {
    if (this.previousElementSibling) {
      this.previousElementSibling.click();
    } else {
      this.parentElement.children[this.parentElement.children.length - 1].click();
    }
  }
}

var CustomizerCategorySelect = class extends HTMLElement {
	constructor() {
		super();
    
    this.productId = this.dataset['productId'];
    this.container = this.closest('product-customizer-bundle');

    this.addEventListener('click', this.handleClick.bind(this));
	}
  

  handleClick() {
    this.container.render(this.productId);
  }
}

var CustomizerColorNavigation = class extends HTMLElement {
  constructor() {
    super();
    
    this.type = this.dataset['type'];
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    if (this.type == "next") {
      document.querySelector('customizer-color-select.button--primary').goToNext();
    } else {
      document.querySelector('customizer-color-select.button--primary').goToPrev();
    }
  }
}

var CustomizerTypeNavigation = class extends HTMLElement {
  constructor() {
    super();
    
    this.type = this.dataset['type'];
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    if (this.type == "next") {
      document.querySelector('customizer-type-select.button--primary').goToNext();
    } else {
      document.querySelector('customizer-type-select.button--primary').goToPrev();
    }
  }
}

if (typeof customElements.get("product-customizer-bundle") === 'undefined') {
  window.customElements.define("product-customizer-bundle", ProductCustomizerBundle);
  window.customElements.define("customizer-color-select", CustomizerColorSelect);
  window.customElements.define("customizer-type-select", CustomizerTypeSelect);
  window.customElements.define("customizer-category-select", CustomizerCategorySelect);
  window.customElements.define("customizer-color-navigation", CustomizerColorNavigation);
  window.customElements.define("customizer-type-navigation", CustomizerTypeNavigation);
}